import API from 'services/API';
import propertyObjectTypes from '../../../../constants/propertyObjectTypes';
import { forEach } from 'lodash';

const transportPrototype = { isHouse: () => false, isLand: () => false, isTransport: () => true };
const objectTypeIdPrototypeMap = {
  [propertyObjectTypes.house]: {
    isHouse: () => true,
    isLand: () => false,
    isTransport: () => false,
  },
  [propertyObjectTypes.land]: {
    isHouse: () => false,
    isLand: () => true,
    isTransport: () => false,
  },
  [propertyObjectTypes.car]: transportPrototype,
  [propertyObjectTypes.boat]: transportPrototype,
  [propertyObjectTypes.plane]: transportPrototype,
};

function LiteObject(object) {
  Object.assign(this, object);
}

export default function getLiteObjects(params) {
  return API.request({
    method: 'GET',
    url: '/taxpayer/krsbs/objects',
    params,
    mapper: (data) => {
      let result = {};
      forEach(data, (object, key) => {
        //save methods into prototype to save memory
        LiteObject.prototype = objectTypeIdPrototypeMap[object.objectTypeId];
        result[key] = new LiteObject(object);
        result[key].id = key;
      });

      return result;
    },
  });
}
